import {ModelTypes} from '@catcore/utils/json-schema';

const infos = {};

infos[ModelTypes.FeatureGgwImplementations] = [
  {
    label: 'Feature Ggw Implementations',
    provide: (feature) => ['features', feature.id, 'ggw-impls'],
  },
];

infos[ModelTypes.FeatureUnit] = [
  {
    label: 'Feature Units',
    provide: (feature) => ['features', feature.id, 'units'],
  },
];

infos[ModelTypes.Feature] = [
  {
    label: 'As part of Feature',
    provide: (feature) => ['features', feature.id, 'properties'],
  },

];

infos[ModelTypes.FeatureGgwDeviceType] = [
  {
    label: 'GGW Devices',
    provide: (feature) => ['features', feature.id, 'ggw-devices'],
  },

];

export const RoutingsForFeatureEntities = infos;



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/shared/routing-command-info.ts